import React, { useEffect, useState } from "react";
import { Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { employeeFilterApiCall } from "../../common/CommonExport";
import { setTableFilter } from "../../redux/slices/tableFilterSlice";

export const handleFilterChange = (
  value: any,
  {
    EmployeeFilter,
    setAllFilterValues,
    setEmployeeData,
    setEmployeeDataSearch,
    confirm,
    setLoader,
    setPopModal,
    setmodalButtonShow,
    setModalErrMessage,
    setModalResponse,
    handleClosePopUpModal,
  }: any
) => {
  employeeFilterApiCall(
    value,
    EmployeeFilter,
    setAllFilterValues,
    setEmployeeData,
    setEmployeeDataSearch,
    setLoader,
    setPopModal,
    setmodalButtonShow,
    setModalErrMessage,
    setModalResponse,
    handleClosePopUpModal
  );
  confirm();
};

const CustomFilterDropdown = ({
  filters,
  confirm,
  EmployeeFilter,
  setAllFilterValues,
  setEmployeeData,
  setEmployeeDataSearch,
  setLoader,
  setPopModal,
  setmodalButtonShow,
  setModalErrMessage,
  setModalResponse,
  handleClosePopUpModal,
}: any) => {
  const dispatch = useDispatch();
  const selectedValue = useSelector(
    (state: any) => state?.tableFilter?.filterValue
  );


  const [open, setOpen] = useState(false);
  const [subSelected, setSubSelected] = useState(false);

  const activeOptions = filters.filter((f: any) =>
    ["Active Employees", "Probation", "Confirmed", "Notice Period", "Appraisal Due"].includes(f.text)
  );

  const mainActiveOption = activeOptions.find(
    (opt: any) => opt?.text === "Active Employees"
  );

  const inlineOptions = activeOptions.filter(
    (opt: any) => opt?.value !== mainActiveOption?.value
  );

  const pastOption = filters?.find((f: any) => f?.text === "Past Employees");
  const allOption = filters?.find((f: any) => f?.text === "All Employees");
  const radioOptions = [pastOption, allOption]?.filter(Boolean);
  useEffect(() => {
    if (inlineOptions.some((opt: any) => opt?.value === selectedValue)) {
      setSubSelected(true);
      setOpen(true);
    }
  }, [selectedValue, inlineOptions]);

  const handleChange = (value: string) => {

    dispatch(setTableFilter(value));


    handleFilterChange(value, {
      EmployeeFilter,
      setAllFilterValues,
      setEmployeeData,
      setEmployeeDataSearch,
      confirm,
      setLoader,
      setPopModal,
      setmodalButtonShow,
      setModalErrMessage,
      setModalResponse,
      handleClosePopUpModal,
    });


    if (inlineOptions?.some((opt: { value: string }) => opt?.value === value)) {
      setSubSelected(true);
      setOpen(true);
    } else {
      setSubSelected(false);
      setOpen(false);
    }


  };

  const toggleOpen = () => {
    if (!subSelected) {
      setOpen((prev) => !prev);
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow border border-gray-200 w-56">
      <div className="flex flex-col space-y-2">

        <div className="flex items-center justify-between">
          <Radio.Group
            value={selectedValue}
            onChange={(e) => handleChange(e.target.value)}
          >
            {mainActiveOption && (
              <Radio
                value={mainActiveOption.value}
                className="text-sm font-medium text-gray-700"
              >
                {mainActiveOption?.text}
              </Radio>
            )}
          </Radio.Group>

          {inlineOptions?.length > 0 && (
            <span
              className="material-symbols-outlined cursor-pointer text-gray-500 hover:text-gray-700"
              onClick={toggleOpen}
            >
              {open ? "expand_less" : "expand_more"}
            </span>
          )}
        </div>

        {/* Inline Active Options */}
        {open && inlineOptions?.length > 0 && (
          <div className="my-3 ml-1 flex flex-col space-y-3 pl-2">
            <Radio.Group
              value={selectedValue}
              onChange={(e) => handleChange(e.target.value)}
            >
              {inlineOptions?.map((opt: any) => (
                <Radio
                  key={opt?.value}
                  value={opt?.value}
                  className="text-sm text-gray-600 hover:text-gray-800"
                >
                  {opt?.text}
                </Radio>
              ))}
            </Radio.Group>
          </div>
        )}
      </div>

      <Radio.Group
        value={selectedValue}
        onChange={(e) => handleChange(e.target.value)}
        className="flex flex-col space-y-2 mt-2"
      >
        {radioOptions?.map((filter: any) => (
          <Radio
            key={filter?.value}
            value={filter?.value}
            className="text-sm font-medium text-gray-700 hover:text-gray-900"
          >
            {filter?.text}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
};

export default CustomFilterDropdown;
